import { StepperSelectionEvent } from '@angular/cdk/stepper';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { ApiHttpService } from '../services/api-http.service';
import { DataService } from '../services/data.service';
import { LoadingOverlayService } from '../shared/loading.service';
import { environment } from 'src/environments/environment';
import { DialogService } from '../shared/dialog/dialog.service';
import saveAs from 'file-saver';
import moment from 'moment';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  @ViewChild('datiAnagrafici', { static: false }) datiAnagrafici: any;
  @ViewChild('datiFornitura', { static: false }) datiFornitura: any;
  @ViewChild('datiPagamento', { static: false }) datiPagamento: any;
  @ViewChild('datiFirma', { static: false }) datiFirma: any;

  confermato = false;
  fornitura?: string;

  constructor(
    public dataService: DataService,
    private http: HttpClient,
    private activatedRoute: ActivatedRoute,
    private httpService: ApiHttpService,
    private loading: LoadingOverlayService,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialog: DialogService
  ) {
    // this.prodotto = this.activatedRoute.snapshot.params.prodotto;
  }

  ngOnInit() {
    this.loading.show();
    // this.prodotto = this.activatedRoute.snapshot.params.prodotto;
    this.activatedRoute.params.subscribe(params => {
      let to_send: any = {
        'prodotto': params.prodotto,
        'auth': params.auth,
      }
      if (params.id_ctr) {
        to_send['id_ctr'] = params.id_ctr;
      }
      this.httpService.get('getProdotto', to_send).subscribe(value => {
        this.dataService.prodotto = value.prodotto;
        this.dataService.prodotto!['tipo_utenza'] = params.tipoUtenza;
        this.dataService.user = value.user;
        this.dataService.dataAuth = value.dataAuth;
        this.dataService.auth = params.auth;
        this.dataService.vendor = value.vendor;
        this.dataService.ctr_data = value.formData;
        this.loading.hide();
      }, error => {
        this.router.navigate(['error']);
        this.loading.hide();
      })
    });
  }

  get _environment() {
    return environment;
  }

  setClass() {
    if (this.dataService.prodotto?.cod_tipo_fornitura_id == 'EE') {
      return 'ee-class';
    } else if (this.dataService.prodotto?.cod_tipo_fornitura_id == 'GAS') {
      return 'gas-class';
    } else {
      return 'ee-gas-class';
    }
  }


  conferma() {
    this.event();

    this.dialog.confirm('Vuoi procedere alla firma del contratto?').then(res => {
      if (!!res) {
        this.loading.show();

        let { _datiAnagrafici, _datiFornitura, _datiFirma } = this.preparaBodyCtr();

        this.httpService.post('salvaPratica', {
          userId: this.dataService.user,
          dataAuth: this.dataService.dataAuth,
          operazione: 'tutto',
          datiAnagrafici: _datiAnagrafici,
          datiFornitura: _datiFornitura,
          datiPagamento: this.dataService.datiPagamento?.getRawValue(),
          datiFirma: _datiFirma,
          prodotto: this.dataService.prodotto,
        }).subscribe(response => {
          this.dataService.codAdesione = response.cod_adesione;
          this.confermato = true;
          this.loading.hide();
          // console.log(response);
          this.snackBar.open('L\'operazione è stata confermata, procedere con la firma del contratto', 'Chiudi', { panelClass: ['snack-success'] });
        }, error => {
          this.confermato = false;
          this.loading.hide();
          // console.log(error);
          this.snackBar.open('Operazione non andata a buon fine', undefined, { panelClass: ['snack-error'], duration: 4000 });
        })

      }
    })
  }

  generaAnteprima() {
    this.event();

    this.loading.show();

    let { _datiAnagrafici, _datiFornitura, _datiFirma } = this.preparaBodyCtr();

    this.httpService.postPDF('salvaPratica', {
      userId: this.dataService.user,
      dataAuth: this.dataService.dataAuth,
      operazione: 'anteprima',
      datiAnagrafici: _datiAnagrafici,
      datiFornitura: _datiFornitura,
      datiPagamento: this.dataService.datiPagamento?.getRawValue(),
      datiFirma: _datiFirma,
      prodotto: this.dataService.prodotto,
    }).subscribe(response => {
      this.loading.hide();
      let blob = new Blob([response], { type: 'application/pdf' });
      saveAs(blob, 'Anteprima contratto.pdf');
    }, error => {
      // this.confermato = false;
      this.loading.hide();
      // if (error.status == 500) {
      //   this.getDocumento(error.codice_adesione);
      // }
      // console.log(error);
      this.snackBar.open('Operazione non andata a buon fine', undefined, { panelClass: ['snack-error'], duration: 4000 });
    })
  }

  // IDEA PROBLEMA LOOP SU IIS
  // getDocumento(codice_adesione: string) {
  //   this.event();

  //   this.loading.show();

  //   let { _datiAnagrafici, _datiFornitura, _datiFirma } = this.preparaBodyCtr();

  //   this.httpService.postPDF('getDocumento', {
  //     codice_adesione: codice_adesione,
  //   }).subscribe(response => {
  //     this.loading.hide();
  //     let blob = new Blob([response], { type: 'application/pdf' });
  //     saveAs(blob, 'Anteprima contratto.pdf');
  //   }, error => {
  //     // this.confermato = false;
  //     this.loading.hide();
  //     if (error.status == 500) {
  //       this.getDocumento(error.codice_adesione);
  //     }
  //     // console.log(error);
  //     this.snackBar.open('Operazione non andata a buon fine', undefined, { panelClass: ['snack-error'], duration: 4000 });
  //   })
  // }

  preparaBodyCtr() {
    let _datiAnagrafici = this.dataService.datiAnagrafici?.getRawValue();
    if (_datiAnagrafici?.rappLegale?.dataDiNascita) {
      _datiAnagrafici['rappLegale']['dataDiNascita'] = _datiAnagrafici['rappLegale']['dataDiNascita'].format('DD/MM/YYYY');
    }
    if (_datiAnagrafici?.amministratore?.dataDiNascita) {
      _datiAnagrafici['amministratore']['dataDiNascita'] = _datiAnagrafici['amministratore']['dataDiNascita'].format('DD/MM/YYYY');
    }
    if (_datiAnagrafici?.cliente?.dataDiNascita) {
      _datiAnagrafici['cliente']['dataDiNascita'] = _datiAnagrafici['cliente']['dataDiNascita'].format('DD/MM/YYYY');
    }

    if (this.dataService.prodotto?.tipo_utenza == 'DOM') {
      _datiAnagrafici.cliente.cellulare = _datiAnagrafici.cliente.cellulare.prefisso + _datiAnagrafici.cliente.cellulare.numero;
    } else {
      _datiAnagrafici.amministratore.cellulare = _datiAnagrafici.amministratore.cellulare.prefisso + _datiAnagrafici.amministratore.cellulare.numero;
      _datiAnagrafici.rappLegale.cellulare = _datiAnagrafici.rappLegale.cellulare.prefisso + _datiAnagrafici.rappLegale.cellulare.numero;
    }

    let _datiFornitura = this.dataService.datiFornitura?.getRawValue();
    _datiFornitura.richieste = _datiFornitura.richieste.map((r: any) => {
      return {
        ...r,
        pods: r.pods.map((pod: any) => {
          let dataDecorrenza = this.minDecorr;
          if (pod.datiTecnici.dataDecorrenza) {
            dataDecorrenza = pod.datiTecnici.dataDecorrenza;
          }
          pod.datiTecnici.dataDecorrenza = dataDecorrenza.format('DD/MM/YYYY');
          pod.datiTecnici.dataFineFornitura = pod.datiTecnici.dataFineFornitura?.format('DD/MM/YYYY')
          // pulisco l'oggetto dai campi nulli
          Object.keys(pod.datiTecnici).forEach(key => {
            if (pod.datiTecnici[key] === null) {
              delete pod.datiTecnici[key];
            }
          });
          return {
            ...pod,
            datiTecnici: {
              ...pod.datiTecnici,
            }
          };
        }),
        pdrs: r.pdrs.map((pdr: any) => {
          if (pdr.datiTecnici?.lettura?.data) {
            pdr.datiTecnici.lettura.data = pdr.datiTecnici.lettura.data.format('DD/MM/YYYY');
          }
          if (pdr.datiTecnici.dataDecorrenza) {
            pdr.datiTecnici.dataDecorrenza = pdr.datiTecnici.dataDecorrenza.format('DD/MM/YYYY');
          }
          // pulisco l'oggetto dai campi nulli
          Object.keys(pdr.datiTecnici).forEach(key => {
            if (pdr.datiTecnici[key] === null) {
              delete pdr.datiTecnici[key];
            }
          });
          return {
            ...pdr,
            datiTecnici: {
              ...pdr.datiTecnici,
              dataFineFornitura: pdr.datiTecnici.dataFineFornitura?.format('DD/MM/YYYY')
            }
          };
        })
      };
    });

    _datiFornitura.richieste.forEach((richiesta: any) => {

      // PODs
      if (richiesta.pods) {
        richiesta.pods.forEach((pod: any) => {
          pod.datiCatastali ||= {};
          if (pod.checkDatiCatastali === '0') {
            // L'utente ha scelto "li comunicherò dopo"
            pod.datiCatastali.assenzaDati = 'SI';
          } else {
            // check = 1 → usa il valore scelto dall'utente ('' oppure '1'..'5')
            pod.datiCatastali.assenzaDati = pod.datiCatastali.assenzaDati ?? '';
          }
        });
      }

      // PDRs
      if (richiesta.pdrs) {
        richiesta.pdrs.forEach((pdr: any) => {
          pdr.datiCatastali ||= {};
          if (pdr.checkDatiCatastali === '0') {
            pdr.datiCatastali.assenzaDati = 'SI';
          } else {
            pdr.datiCatastali.assenzaDati = pdr.datiCatastali.assenzaDati ?? '';
          }

        });
      }
    });

    let _datiFirma = this.dataService.datiFirma?.getRawValue();
    _datiFirma.datiFirmaDigitale.telefono = _datiFirma.datiFirmaDigitale.telefono.prefisso + _datiFirma.datiFirmaDigitale.telefono.numero;

    return { _datiAnagrafici, _datiFornitura, _datiFirma };
  }

  getContratto() {
    this.httpService.postPDF('getContratto', {
      codAdesione: this.dataService.codAdesione,
      dataAuth: this.dataService.dataAuth,
    }).subscribe(response => {
      this.loading.hide();
      let blob = new Blob([response], { type: 'application/pdf' });
      saveAs(blob, this.dataService.codAdesione + '.pdf');
    }, error => {
      this.loading.hide();
      this.snackBar.open('Operazione non andata a buon fine', undefined, { panelClass: ['snack-error'], duration: 4000 });
    })
  }

  // apriAnteprima() {
  //   const fileURL = window.URL.createObjectURL(this.anteprimaBlob);
  //   window.open(fileURL);
  // }

  event(evento?: StepperSelectionEvent) {
    this.dataService.datiAnagrafici = this.datiAnagrafici.datiAnaForm;
    this.dataService.datiFornitura = this.datiFornitura.datiFornForm;
    this.dataService.datiPagamento = this.datiPagamento.datiFattForm;
    this.dataService.datiFirma = this.datiFirma.datiFirmaForm;

    if (this.dataService.prodotto?.tipo_utenza == 'DOM') {
      if (!this.datiPagamento.datiFattForm.get('titolareConto').get('codiceFiscale').value) {
        this.datiPagamento.datiFattForm.get('titolareConto').get('codiceFiscale').setValue(this.datiAnagrafici.datiAnaForm.get('cliente').get('codiceFiscale').value)
      }
      if (!this.datiPagamento.datiFattForm.get('sottoscrittore').get('codiceFiscale').value) {
        this.datiPagamento.datiFattForm.get('sottoscrittore').get('codiceFiscale').setValue(this.datiAnagrafici.datiAnaForm.get('cliente').get('codiceFiscale').value)
      }
    } else if (this.dataService.prodotto?.tipo_utenza == 'BUS' && this.datiAnagrafici.datiAnaForm.get('tipoCliente').value == '0') {
      if (this.datiPagamento.datiFattForm.get('sottoscrittore')?.get('codiceFiscale').value) {
        this.datiPagamento.datiFattForm.get('sottoscrittore')?.get('codiceFiscale')?.setValue(this.datiAnagrafici.datiAnaForm.get('rappLegale').get('codiceFiscale').value);
      }
    }

    // dati anagrafici
    if (evento?.previouslySelectedIndex == 0) {
      this.datiFornitura.volume_cerved = this.dataService.volume_cerved;
      if (this.datiFornitura.volume_cerved){
        this.datiFornitura.richieste.controls.forEach((richiestaGroup: FormGroup) => {
          this.datiFornitura.pods(richiestaGroup).controls.forEach((podGroup: FormGroup) => {
            podGroup.get('datiTecnici')?.get('volume')?.setValue(this.dataService.volume_cerved, { emitEvent: false });
            // podGroup.get('datiTecnici')?.get('volume')?.disable();
          })
          this.datiFornitura.pdrs(richiestaGroup).controls.forEach((pdrGroup: FormGroup) => {
            pdrGroup.get('datiTecnici')?.get('consumoAnnuo')?.setValue(this.dataService.volume_cerved, { emitEvent: false });
            // pdrGroup.get('datiTecnici')?.get('consumoAnnuo')?.disable();
          })
        })
      }
      if (!this.datiFirma.datiFirmaForm.get('datiFirmaDigitale')?.get('telefono')?.get('numero')?.value) {
        if (this.dataService.prodotto?.tipo_utenza == 'DOM') {
          this.datiFirma.datiFirmaForm.get('datiFirmaDigitale')?.patchValue({ telefono: this.datiAnagrafici.datiAnaForm?.get('cliente')?.get('cellulare')?.value });
        } else {
          if (this.datiAnagrafici.datiAnaForm.get('tipoCliente').value == '0') {
            this.datiFirma.datiFirmaForm.get('datiFirmaDigitale')?.patchValue({ telefono: this.datiAnagrafici.datiAnaForm.get('rappLegale').get('cellulare').value });
          } else {
            this.datiFirma.datiFirmaForm.get('datiFirmaDigitale')?.patchValue({ telefono: this.datiAnagrafici.datiAnaForm.get('amministratore').get('cellulare').value });
          }
        }
      }

      // pagamento e fatturazione
    } else if (evento?.previouslySelectedIndex == 2) {
      if (!this.datiFirma.datiFirmaForm.get('datiFirmaDigitale')?.get('email')?.value) {
        this.datiFirma.datiFirmaForm?.get('datiFirmaDigitale')?.patchValue({ email: (this.datiPagamento.datiFattForm?.get('mails') as FormArray).at(0).value });
      }
    }
  }

  get minDecorr() {
    let _data = moment();
    if (_data.day() <= 10) {
      return moment().add(1, 'months').startOf('month');
    } else {
      return moment().add(2, 'months').startOf('month');
    }
  }
}